import get from "lodash/get";

import exported from "./exported.json";

function extractFont(path: string): React.CSSProperties {
  const font = get(exported, "typography." + path);

  return {
    fontSize: `${font.fontSize.value}px`,
    textDecoration: font.textDecoration.value,
    fontFamily: font.fontFamily.value,
    fontWeight: font.fontWeight.value,
    fontStyle: font.fontStyle.value,
    fontStretch: font.fontStretch.value,
    letterSpacing: `${font.letterSpacing.value}px`,
    lineHeight: font.lineHeight.value / font.fontSize.value,
  };
}

export const externalFonts = () => ({
  paragraph_xxlarge_regular: extractFont("paragraph.xxlarge.regular"),
  paragraph_xxlarge_medium: extractFont("paragraph.xxlarge.medium"),
  paragraph_xxlarge_semibold: extractFont("paragraph.xxlarge.semibold"),
  paragraph_xlarge_regular: extractFont("paragraph.xlarge.regular"),
  paragraph_xlarge_medium: extractFont("paragraph.xlarge.medium"),
  paragraph_xlarge_semibold: extractFont("paragraph.xlarge.semibold"),
  paragraph_large_regular: extractFont("paragraph.large.regular"),
  paragraph_large_medium: extractFont("paragraph.large.medium"),
  paragraph_large_semibold: extractFont("paragraph.large.semibold"),
  paragraph_large_special_underline: extractFont(
    "paragraph.large.special.underline",
  ),
  paragraph_large_special_strikethrough: extractFont(
    "paragraph.large.special.strikethrough",
  ),
  paragraph_large_special_italics: extractFont(
    "paragraph.large.special.italics",
  ),
  paragraph_medium_regular: extractFont("paragraph.medium.regular"),
  paragraph_medium_medium: extractFont("paragraph.medium.medium"),
  paragraph_medium_semibold: extractFont("paragraph.medium.semibold"),
  paragraph_medium_special_underline: extractFont(
    "paragraph.medium.special.underline",
  ),
  paragraph_medium_special_strikethrough: extractFont(
    "paragraph.medium.special.strikethrough",
  ),
  paragraph_medium_special_italics: extractFont(
    "paragraph.medium.special.italics",
  ),
  paragraph_small_regular: extractFont("paragraph.small.regular"),
  paragraph_small_medium: extractFont("paragraph.small.medium"),
  paragraph_small_semibold: extractFont("paragraph.small.semibold"),
  paragraph_small_special_underline: extractFont(
    "paragraph.small.special.underline",
  ),
  paragraph_small_special_strikethrough: extractFont(
    "paragraph.small.special.strikethrough",
  ),
  paragraph_small_special_italics: extractFont(
    "paragraph.small.special.italics",
  ),
  paragraph_xsmall_regular: extractFont("paragraph.xsmall.regular"),
  paragraph_xsmall_medium: extractFont("paragraph.xsmall.medium"),
  paragraph_xsmall_semibold: extractFont("paragraph.xsmall.semibold"),
  paragraph_xsmall_special_underline: extractFont(
    "paragraph.xsmall.special.underline",
  ),
  paragraph_xsmall_special_strikethrough: extractFont(
    "paragraph.xsmall.special.strikethrough",
  ),
  paragraph_xsmall_special_italics: extractFont(
    "paragraph.xsmall.special.italics",
  ),
  paragraph_overline_large: extractFont("paragraph.overline.large"),
  paragraph_overline_small: extractFont("paragraph.overline.small"),
  heading_h1_medium_mobile: extractFont("heading.h1.medium.mobile"),
  heading_h1_medium_tablet: extractFont("heading.h1.medium.tablet"),
  heading_h1_medium_desktop: extractFont("heading.h1.medium.desktop"),
  heading_h1_semibold_mobile: extractFont("heading.h1.semibold.mobile"),
  heading_h1_semibold_tablet: extractFont("heading.h1.semibold.tablet"),
  heading_h1_semibold_desktop: extractFont("heading.h1.semibold.desktop"),
  heading_h1_bold_mobile: extractFont("heading.h1.bold.mobile"),
  heading_h1_bold_tablet: extractFont("heading.h1.bold.tablet"),
  heading_h1_bold_desktop: extractFont("heading.h1.bold.desktop"),
  heading_h1_extrabold_mobile: extractFont("heading.h1.extrabold.mobile"),
  heading_h1_extrabold_tablet: extractFont("heading.h1.extrabold.tablet"),
  heading_h1_extrabold_desktop: extractFont("heading.h1.extrabold.desktop"),
  heading_h2_medium_mobile: extractFont("heading.h2.medium.mobile"),
  heading_h2_medium_tablet: extractFont("heading.h2.medium.tablet"),
  heading_h2_medium_desktop: extractFont("heading.h2.medium.desktop"),
  heading_h2_semibold_mobile: extractFont("heading.h2.semibold.mobile"),
  heading_h2_semibold_tablet: extractFont("heading.h2.semibold.tablet"),
  heading_h2_semibold_desktop: extractFont("heading.h2.semibold.desktop"),
  heading_h2_bold_mobile: extractFont("heading.h2.bold.mobile"),
  heading_h2_bold_tablet: extractFont("heading.h2.bold.tablet"),
  heading_h2_bold_desktop: extractFont("heading.h2.bold.desktop"),
  heading_h2_extrabold_mobile: extractFont("heading.h2.extrabold.mobile"),
  heading_h2_extrabold_tablet: extractFont("heading.h2.extrabold.tablet"),
  heading_h2_extrabold_desktop: extractFont("heading.h2.extrabold.desktop"),
  heading_h3_medium_mobile: extractFont("heading.h3.medium.mobile"),
  heading_h3_medium_tablet: extractFont("heading.h3.medium.tablet"),
  heading_h3_medium_desktop: extractFont("heading.h3.medium.desktop"),
  heading_h3_semibold_mobile: extractFont("heading.h3.semibold.mobile"),
  heading_h3_semibold_tablet: extractFont("heading.h3.semibold.tablet"),
  heading_h3_semibold_desktop: extractFont("heading.h3.semibold.desktop"),
  heading_h3_bold_mobile: extractFont("heading.h3.bold.mobile"),
  heading_h3_bold_tablet: extractFont("heading.h3.bold.tablet"),
  heading_h3_bold_desktop: extractFont("heading.h3.bold.desktop"),
  heading_h3_extrabold_mobile: extractFont("heading.h3.extrabold.mobile"),
  heading_h3_extrabold_tablet: extractFont("heading.h3.extrabold.tablet"),
  heading_h3_extrabold_desktop: extractFont("heading.h3.extrabold.desktop"),
  heading_h4_medium_mobile: extractFont("heading.h4.medium.mobile"),
  heading_h4_medium_tablet: extractFont("heading.h4.medium.tablet"),
  heading_h4_medium_desktop: extractFont("heading.h4.medium.desktop"),
  heading_h4_semibold_mobile: extractFont("heading.h4.semibold.mobile"),
  heading_h4_semibold_tablet: extractFont("heading.h4.semibold.tablet"),
  heading_h4_semibold_desktop: extractFont("heading.h4.semibold.desktop"),
  heading_h4_bold_mobile: extractFont("heading.h4.bold.mobile"),
  heading_h4_bold_tablet: extractFont("heading.h4.bold.tablet"),
  heading_h4_bold_desktop: extractFont("heading.h4.bold.desktop"),
  heading_h4_extrabold_mobile: extractFont("heading.h4.extrabold.mobile"),
  heading_h4_extrabold_tablet: extractFont("heading.h4.extrabold.tablet"),
  heading_h4_extrabold_desktop: extractFont("heading.h4.extrabold.desktop"),
  heading_h5_medium_mobile: extractFont("heading.h5.medium.mobile"),
  heading_h5_medium_tablet: extractFont("heading.h5.medium.tablet"),
  heading_h5_medium_desktop: extractFont("heading.h5.medium.desktop"),
  heading_h5_semibold_mobile: extractFont("heading.h5.semibold.mobile"),
  heading_h5_semibold_tablet: extractFont("heading.h5.semibold.tablet"),
  heading_h5_semibold_desktop: extractFont("heading.h5.semibold.desktop"),
  heading_h5_bold_mobile: extractFont("heading.h5.bold.mobile"),
  heading_h5_bold_tablet: extractFont("heading.h5.bold.tablet"),
  heading_h5_bold_desktop: extractFont("heading.h5.bold.desktop"),
  heading_h5_extrabold_mobile: extractFont("heading.h5.extrabold.mobile"),
  heading_h5_extrabold_tablet: extractFont("heading.h5.extrabold.tablet"),
  heading_h5_extrabold_desktop: extractFont("heading.h5.extrabold.desktop"),
  heading_h6_medium_mobile: extractFont("heading.h6.medium.mobile"),
  heading_h6_medium_tablet: extractFont("heading.h6.medium.tablet"),
  heading_h6_medium_desktop: extractFont("heading.h6.medium.desktop"),
  heading_h6_semibold_mobile: extractFont("heading.h6.semibold.mobile"),
  heading_h6_semibold_tablet: extractFont("heading.h6.semibold.tablet"),
  heading_h6_semibold_desktop: extractFont("heading.h6.semibold.desktop"),
  heading_h6_bold_mobile: extractFont("heading.h6.bold.mobile"),
  heading_h6_bold_tablet: extractFont("heading.h6.bold.tablet"),
  heading_h6_bold_desktop: extractFont("heading.h6.bold.desktop"),
  heading_h6_extrabold_mobile: extractFont("heading.h6.extrabold.mobile"),
  heading_h6_extrabold_tablet: extractFont("heading.h6.extrabold.tablet"),
  heading_h6_extrabold_desktop: extractFont("heading.h6.extrabold.desktop"),
  display_medium_large: extractFont("display.medium.large"),
  display_medium_small: extractFont("display.medium.small"),
  display_semibold_large: extractFont("display.semibold.large"),
  display_semibold_small: extractFont("display.semibold.small"),
  display_bold_large: extractFont("display.bold.large"),
  display_bold_small: extractFont("display.bold.small"),
  display_extrabold_large: extractFont("display.extrabold.large"),
  display_extrabold_small: extractFont("display.extrabold.small"),
});

type ExternalFonts = keyof ReturnType<typeof externalFonts>;

export type ExternalFontsTypographyVariants = {
  [Key in ExternalFonts]: React.CSSProperties;
};

export type ExternalFontsTypographyVariantsOptions = {
  [Key in ExternalFonts]?: React.CSSProperties;
};

export type ExternalFontsTypographyPropsVariantOverrides = {
  [Key in ExternalFonts]: true;
};
